import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import {
  GET_CALL_HISTORY,
  GetCallHistoryAction,
  GetCallHistoryFailureAction,
  GetCallHistorySuccessAction,
  SetCallHistoryParamsAction
} from './call-history.actions';
import { CallHistoryService } from './call-history.service';
import { CallHistoryCall, CallHistorySearchParams } from './call-history-params.interface';
import { select, Store } from '@ngrx/store';
import { getCallHistoryPageSelector } from './call-history.reducer';
import { IState } from '../shared/models/state';

@Injectable()
export class CallHistoryEffects {
  @Effect()
  getCallHistory$: Observable<any> = this.actions$.pipe(
    ofType(GET_CALL_HISTORY),
    map((action: GetCallHistoryAction) => action.payload),
    withLatestFrom(this.store.pipe(select(getCallHistoryPageSelector))),
    switchMap(([payload, params]: [CallHistorySearchParams, CallHistorySearchParams]) => {
      const completeParams: CallHistorySearchParams = { ...params, ...payload };
      return this.callHistoryService.getCallHistory(this.escapeUnassignedUser(completeParams)).pipe(
        switchMap((response: { data: CallHistoryCall[]; total: number }) => {
          return [new GetCallHistorySuccessAction(response), new SetCallHistoryParamsAction(completeParams)];
        }),
        catchError(error => of(new GetCallHistoryFailureAction(error)))
      );
    })
  );

  constructor(
    private actions$: Actions,
    private callHistoryService: CallHistoryService,
    private store: Store<IState>
  ) {}

  private escapeUnassignedUser(searchParams: CallHistorySearchParams): CallHistorySearchParams {
    const agentIds = (searchParams && searchParams.agentIds ? searchParams.agentIds : []).map(
      id => (id === CallHistoryService.UNASSIGNED_USER_ID ? null : id)
    );
    return { ...searchParams, agentIds };
  }
}
